export const certifications = [
    {
      title: "Agentic AI with LangChain and LangGraph",
      organization: "IBM",
      issueDate: "Aug 2025",
      certificateImage: "/agentic%20ai%20with%20langchain%20certificate.jpg",
      skills: [
        "Artificial Intelligence and Machine Learning (AI/ML)",
        "Data Science",
        "Generative AI Agents",
        "Agentic systems",
        "System Design and Implementation",
        "Python"
      ],
      description: "Hands-on course by IBM on building agentic AI systems using LangChain and LangGraph, covering Reflection, Reflexion, ReAct, agentic RAG, orchestration strategies, and more."
    },
    {
      title: "AI Agent: From Prototype to Production",
      organization: "Frontend Masters",
      issueDate: "Jul 2025",
      credentialId: "004f649fe2-NKUwJieTvI",
      certificateImage: "/certificates/ai-agent-production.jpg",
      skills: ["AI Software Development", "Retrieval-Augmented Generation (RAG)"],
      description: "Build production-ready AI apps with RAG, evals, structured outputs, and human-in-the-loop best practices for safe and reliable deployments."
    },
    {
      title: "Practical Guide to Python",
      organization: "Frontend Masters",
      issueDate: "Jun 2025",
      credentialId: "004f649fe2-ZfBjFwyWWj",
      certificateImage: "/certificates/python-guide.jpg",
      skills: ["Python"],
      description: "Covers Python foundations, practical applications, libraries, and building apps with Django."
    },
    {
      title: "Hard Parts of AI: Neural Networks",
      organization: "Frontend Masters",
      issueDate: "Apr 2025",
      credentialId: "004f649fe2-ASgTLkgjgF",
      certificateImage: "/certificates/hard-parts-ai.jpg",
      skills: ["Neural Networks", "Deep Learning", "Prompt Engineering"],
      description: "Explores how prediction and neural networks work, including training, decision models, and production-ready implementations."
    },
    {
      title: "Ethics in the Age of Generative AI",
      organization: "LinkedIn",
      issueDate: "Nov 2024",
      certificateImage: "/certificates/ethics-genai.jpg",
      skills: ["AI Ethics"],
      description: "Explores ethical concerns and responsibilities in building and deploying generative AI technologies."
    },
    {
      title: "Build AI-Powered Apps with OpenAI and Node.js",
      organization: "Frontend Masters",
      issueDate: "Sep 2024",
      credentialId: "5e97e2c418-mzWSRHSwZc",
      certificateImage: "/certificates/ai-node-openai.jpg",
      skills: [
        "AI Software Development",
        "Vector Databases",
        "OpenAI API",
        "Prompt Engineering",
        "RAG"
      ],
      description: "Integrate Node.js with OpenAI to build chat interfaces, semantic search, function calling, and image generation."
    },
    {
      title: "Systems Expert",
      organization: "AlgoExpert",
      issueDate: "Apr 2024",
      certificateImage: "/certificates/systems-expert.jpg",
      skills: ["System Design"],
      description: "Advanced system design concepts covering scalability, fault-tolerance, and architectural patterns."
    },
    {
      title: "Advanced Data Modeling",
      organization: "Meta",
      issueDate: "Jul 2023",
      certificateImage: "/certificates/meta-data-modeling.jpg",
      skills: ["Data Analytics", "Data Modeling"],
      description: "Teaches advanced data modeling for large-scale analytics and complex systems."
    },
    {
      title: "Amazon DynamoDB - Architecture and Features",
      organization: "Amazon Web Services (AWS)",
      issueDate: "Feb 2023",
      certificateImage: "/certificates/dynamodb-aws.jpg",
      skills: ["AWS"],
      description: "Covers DynamoDB's architecture, features, and use cases for high-performance NoSQL databases."
    },
    {
      title: "Blockchain Scalability and its Foundations in Distributed Systems",
      organization: "University of Sydney",
      issueDate: "Jul 2022",
      certificateImage: "/certificates/blockchain-scalability.jpg",
      skills: ["Blockchain"],
      description: "Explores consensus algorithms, scalability solutions, and distributed systems design for blockchain."
    },
    {
      title: "Blockchain: Foundations and Use Cases",
      organization: "Consensys Academy",
      issueDate: "Jul 2022",
      certificateImage: "/certificates/blockchain-foundations.jpg",
      skills: ["Blockchain"],
      description: "Intro to blockchain concepts, Ethereum, smart contracts, and real-world applications."
    },
    {
      title: "Decentralised Finance Infrastructure",
      organization: "Duke University",
      issueDate: "Jul 2022",
      certificateImage: "/certificates/defi-infrastructure.jpg",
      description: "Covers DeFi ecosystem, lending/borrowing protocols, and decentralized exchanges."
    },
    {
      title: "Smart Contracts",
      organization: "University at Buffalo",
      issueDate: "Jul 2022",
      certificateImage: "/certificates/smart-contracts.jpg",
      skills: ["Blockchain"],
      description: "Deep dive into smart contract design, security, and testing using Solidity and Ethereum."
    },
    {
      title: "Blockchain – Principles and Practices",
      organization: "Pluralsight",
      issueDate: "Feb 2022",
      certificateImage: "/certificates/blockchain-pluralsight.jpg",
      skills: ["Blockchain"],
      description: "Foundational blockchain knowledge including hash functions, consensus models, and use cases."
    },
    {
      title: "React (Basic)",
      organization: "HackerRank",
      issueDate: "Oct 2021",
      certificateImage: "/certificates/react-basic.jpg",
      skills: ["React"],
      description: "Demonstrates foundational React knowledge for frontend development."
    },
    {
      title: "Agile Project Leadership",
      organization: "LinkedIn",
      issueDate: "Sep 2021",
      certificateImage: "/certificates/agile-leadership.jpg",
      description: "Covers leading Agile teams, project vision, velocity, and communication practices."
    },
    {
      title: "Blockchain: Beyond the Basics",
      organization: "LinkedIn",
      issueDate: "Sep 2021",
      certificateImage: "/certificates/blockchain-advanced.jpg",
      skills: ["Blockchain"],
      description: "Deeper look into blockchain infrastructure, tokenization, and enterprise use cases."
    },
    {
      // eslint-disable-next-line no-script-url
      title: "JavaScript: Patterns",
      organization: "LinkedIn",
      issueDate: "Sep 2021",
      certificateImage: "/certificates/js-patterns.jpg",
      description: "Explores key JS patterns including Module, Revealing Module, Singleton, and Observer."
    },
    {
      // eslint-disable-next-line no-script-url
      title: "JavaScript: Test-Driven Development (ES6)",
      organization: "LinkedIn",
      issueDate: "Sep 2021",
      certificateImage: "/certificates/js-tdd.jpg",
      description: "Focuses on testing in modern JavaScript using ES6+ and TDD principles."
    },
    {
      title: "CSS: Design Systems and Architectures",
      organization: "LinkedIn",
      issueDate: "Aug 2021",
      certificateImage: "/certificates/css-design-systems.jpg",
      description: "Best practices for building scalable, maintainable, and reusable CSS architectures."
    },
    {
      title: "React: Securing Applications",
      organization: "LinkedIn",
      issueDate: "Aug 2021",
      certificateImage: "/certificates/react-security.jpg",
      description: "Security best practices for React apps including XSS protection and auth flows."
    },
    {
      title: "React: Software Architecture",
      organization: "LinkedIn",
      issueDate: "Aug 2021",
      certificateImage: "/certificates/react-architecture.jpg",
      description: "Teaches building large-scale React apps with clean, modular architecture."
    },
    {
      title: "Scrum Foundation Professional Certificate",
      organization: "CertiProf",
      issueDate: "Aug 2021",
      certificateImage: "/certificates/scrum-certiprof.jpg",
      description: "Foundation-level understanding of Scrum roles, artifacts, and ceremonies."
    },
    {
      title: "Blockchain Essentials",
      organization: "IBM",
      issueDate: "Mar 2021",
      credentialId: "3a1f0fe905f84bdc88163d4fb0ceb493",
      certificateImage: "/certificates/blockchain-ibm.jpg",
      skills: ["Blockchain"],
      description: "Intro to blockchain concepts, how it works, and where it is used in enterprises."
    }
  ];
